import { useNavigate } from 'react-router-dom'
import { MyProfile } from '@/components/MyProfile'
import { AccountPage } from './account/AccountPage'

/** `/my/profile` — display name, email and avatar. */
export function MyProfilePage() {
  const navigate = useNavigate()

  return (
    <AccountPage title="My Profile">
      <MyProfile onClose={() => navigate('/')} />
    </AccountPage>
  )
}
